import * as React from "react";
import Box from "@mui/material/Box";

export interface TabPanelContainerProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabPanelContainer = (props: TabPanelContainerProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export const tabProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
  };
};
